import React from "react";
import "../Forms/css/addDirectory.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { connect } from "react-redux";
import axios from "axios";
import io from "socket.io-client";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
const token = localStorage.getItem('authToken');
class AddDirectory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imageInput: [],
      textInput: "",
      refCode: "",
      userName: "",
      emailInput: "",
      state: "",
      city: "",
      pinCode: "",
     
      bloodGroup: "",
      nativeOf: "",
      district: "",
      kulName: "",
      caste: "",
      subcaste: "",
      gotra: "",
      areaInput: "",
      firmName: "",
      firmAddress: "",
      dealsWith: "",
      contact: "",
      website: "",
      category: "",
      categoryData: [],
      caste: "",
      casteData: [],
      images: [],
      maxSize: 5 * 1024 * 1024, // 5MB in bytes
      errors: [],
      currentImageUrls: [],
      submissionStatus: null,
      currentImageUrl: null,
      submeet: false,
      password: '',
      confirmPassword: '',
      showPassword: false,
      showPasswordConfirm: false,
      gender: "",
      errorMessages: [],
    };
    this.handleBloodDonateChange = this.handleBloodDonateChange.bind(this);
    this.socket = io('https://samaj.aasmo.in/');
  }

  componentDidMount() {
    this.socket.on('newJobNotification', (notification) => {
      alert(notification.message);
    });

    this.fetchData();
    this.getData()
  }

  componentWillUnmount() {
    this.socket.disconnect();
  }

  fetchData = async () => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/occupation`);
      console.log(response,"Occupation")
      if (response.data) {
        this.setState({ categoryData: response.data.categories });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
 getData = async () => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/caste`, {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
      console.log(response.data.entries,"pp");
      if (response.data) {
        this.setState({ casteData:response.data.entries });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    
  };
  handleBloodDonateChange(e) {
    this.setState({ bloodDonate: e.target.value });
  }

  handleNativeOfChange = (e) => {
    const nativeOf = e.target.value;
    this.setState({ nativeOf, district: "", homeCity: "" });
  };

  handleDistrictChange = (e) => {
    const district = e.target.value;
    this.setState({ district, homeCity: "" });
  };

  handleCityChange = (e) => {
    const homeCity = e.target.value;
    this.setState({ homeCity });
  };

  handleCasteChange = (e) => {
    const caste = e.target.value;
    this.setState({ caste, subcaste: "", gotra: "" });
  };

  handleSubcasteChange = (e) => {
    const subcaste = e.target.value;
    this.setState({ subcaste, gotra: "" });
  };

  handleGotraChange = (e) => {
    const gotra = e.target.value;
    this.setState({ gotra });
  };

  handleChange = (e) => {
    const files = Array.from(e.target.files);
    const errors = [];

    files.forEach((file) => {
      if (file.size > this.state.maxSize) {
        errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
      } else {
        this.setState({
          textInput: file,
          currentImageUrl: URL.createObjectURL(file), // Update current image URL to show the new image
        });
      }
    });

    this.setState({ errors });
  };

  handleChangeMultipleImages = (e) => {
    const files = Array.from(e.target.files);
    const errors = [];

    const selectedImages = files.filter((file) => {
      const isValidSize = file.size <= this.state.maxSize;
      if (!isValidSize) {
        errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
      }
      return isValidSize;
    });

    this.setState({
      imageInput: selectedImages,
      currentImageUrls: selectedImages.map((file) => URL.createObjectURL(file)), // Update current image URLs to show the new images
      errors,
    });
  };
  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  };
  togglePasswordVisibilityConfirm = () => {
    this.setState((prevState) => ({
      showPasswordConfirm: !prevState.showPasswordConfirm,
    }));
  };
  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ submeet: true, errorMessages: [] }); // Clear previous errors
    try {
      // Extract state variables and set up FormData
      const {
        imageInput,
        textInput,
        emailInput,
        areaInput,
        userName,
        state,
        city,
        pinCode,
        bloodGroup,
        bloodDonate,
        nativeOf,
        district,
        homeCity,
        kulName,
        caste,
        subcaste,
        gotra,
        firmName,
        firmAddress,
        dealsWith,
        contact,
        gender,
        website,
        category,
        password
      } = this.state;
  
      const formData = new FormData();
  
      // Append single image (if textInput is a file)
      if (textInput instanceof File) {
        formData.append('image', textInput);
      }
  
      // Append multiple business images
      imageInput.forEach((file) => {
        formData.append('businessImages', file);
      });
  
      // Append other form fields
      formData.append('email', emailInput);
      formData.append('address', areaInput);
      formData.append('fullName', userName);
      formData.append('state', state);
      formData.append('city', city);
      formData.append('pincode', pinCode);
      formData.append('bloodGroup', bloodGroup);
      formData.append('bloodYN', bloodDonate);
      formData.append('nativeOf', nativeOf);
      formData.append('homeDistrict', district);
      formData.append('homeCity', homeCity); 
      formData.append('kuldeviName', kulName);
      formData.append('caste', caste);
      formData.append('subcaste', subcaste);
      formData.append('gotra', gotra);
      formData.append('selectedJobCategories', category); 
      formData.append('businessProfile[firmName]', firmName);
      formData.append('businessProfile[firmAddress]', firmAddress);
      formData.append('businessProfile[dealsWith]', dealsWith);
      formData.append('contactNo', contact);
      formData.append('businessProfile[website]', website);
      formData.append('password', password);
      formData.append('gender', gender);
  
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${this.state.token}` // Make sure token is correctly set
        }
      };
  
      console.log('Form Data:', formData); // Log the formData for debugging
  
      const response = await axios.post("https://samaj.aasmo.in/api/admin/registeruser", formData, config);
      console.log('Response:', response); // Log the response for debugging
  
      if (response && response.status === 201) {
        this.setState({ submissionStatus: 'success' });
        this.socket.emit('newJobAdded', { message: 'A new job has been added!' });
        console.log('newJobAdded', { message: 'A new job has been added!' });
        console.log('Form submitted successfully');
        setTimeout(() => {
          this.props.history.push("/tablenormal")
        }, 2000);
      } else {
        console.log('Unexpected response:', response);
      }
    } catch (error) {
      console.error('Error submitting form:', error); // Log the error for debugging
      
      // Update state with error messages
      if (error.response) {
        const errorMessages = [];
        if (error.response.status === 400) {
          errorMessages.push('Bad request error: ' + (error.response.data.message || 'Invalid data'));
        } else if (error.response.status === 401) {
          errorMessages.push('Unauthorized error, please log in again.');
        } else {
          errorMessages.push('An unexpected error occurred: ' + (error.response.data.message || 'Something went wrong'));
        }
        this.setState({ errorMessages });
      } else {
        this.setState({ errorMessages: ['Network error, please try again later.'] });
      }
    }
  };
  

  

  render() {
    const { textInput, gender,errorMessages,imageInput,password, confirmPassword, showPassword,casteData, showPasswordConfirm, category, categoryData, currentImageUrl, refCode, emailInput, areaInput, submeet, userName, state, city, pinCode, bloodGroup, nativeOf, district, kulName, caste, subcaste, gotra, firmName, firmAddress, dealsWith, contact, website, bloodDonate, homeCity, submissionStatus
    } = this.state;
  
    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Add Directory Member</h2>
          </div>
          <div className="body">
            <form className="ng-untouched ng-dirty ng-invalid">

              <div className="form-group">
                <label>Profile Photo</label>

                {currentImageUrl && (
                  <div>
                    <img src={currentImageUrl} alt="Current" style={{ width: '100px', marginBottom: '10px' }} />
                  </div>
                )}
                <input
                  type="file"
                  className={`form-control ${!textInput}`}
                  name="textInput"
                  required=""
                  onChange={this.handleChange}
                />
                {!textInput && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>


              <div className="form-group">
                <label>Name</label>
                <input
                  className={`form-control ${ !userName 
                    }`}
                  value={userName}
                  name="userName"
                 
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ userName: e.target.value });
                  }}
                />
                {submeet && (!userName) ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>Contact No :</label>
                <input
                  className={`form-control ${(contact) 
                    }`}
                  value={contact}
                  name="contact"
                
                  // required=""
                  type="number"
                  onChange={(e) => {
                    this.setState({ contact: e.target.value });
                  }}
                />
                {submeet && !(contact) ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
      <label>Gender</label>
      <select
        className={`form-control ${submeet && !gender && "parsley-error"}`}
        value={gender}
        name="gender"
        required=""
        onChange={(e) => {
          this.setState({ gender: e.target.value });
        }}
      >
        <option value="">Select Gender</option>
        <option value="Male">Male</option>
        <option value="Female">Female</option>
        <option value="Other">Other</option>
      </select>
      {submeet && !gender ? (
        <ul className="parsley-errors-list filled" id="parsley-id-29">
          <li className="parsley-required">Gender is required.</li>
        </ul>
      ) : null}
    </div>

                  <div className="form-group">
                <label>Email :</label>
                <input
                  className={`form-control ${!(emailInput) 
                    }`}
                  value={emailInput}
                  name="emailInput"
                  pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                  // required=""
                  type="email"
                  onChange={(e) => {
                    this.setState({ emailInput: e.target.value });
                  }}
                />
                {submeet && !(emailInput) ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
          <label>Password</label>
          <div className="password-input-container">
            <input
              className={`form-control ${!password && submeet && 'parsley-error'}`}
              value={password}
              name="password"
              type={showPassword ? 'text' : 'password'}
              onChange={(e) => {
                this.setState({ password: e.target.value });
              }}
            />
            <span className="password-toggle-icon" onClick={this.togglePasswordVisibility}>
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </span>
          </div>
          {!password && submeet ? (
            <ul className="parsley-errors-list filled">
              <li className="parsley-required">Password is required.</li>
            </ul>
          ) : null}
        </div>

        <div className="form-group">
          <label>Confirm Password</label>
          <div className="password-input-container">
            <input
              className={`form-control ${password !== confirmPassword && submeet && 'parsley-error'}`}
              value={confirmPassword}
              name="confirmPassword"
              type={showPasswordConfirm ? 'text' : 'password'}
              onChange={(e) => {
                this.setState({ confirmPassword: e.target.value });
              }}
            />
            <span className="password-toggle-icon" onClick={this.togglePasswordVisibilityConfirm}>
              <FontAwesomeIcon icon={showPasswordConfirm ? faEyeSlash : faEye} />
            </span>
          </div>
          {password !== confirmPassword && submeet ? (
            <ul className="parsley-errors-list filled">
              <li className="parsley-required">Passwords do not match.</li>
            </ul>
          ) : null}
        </div>


              <div className="form-group">
                <label>Current Address</label>
                <textarea
                  className={`form-control ${areaInput === "" && submeet && "parsley-error"
                    }`}
                  value={areaInput}
                  cols="30"
                  name="textarea"
                  required=""
                  rows="5"
                  onChange={(e) => {
                    this.setState({ areaInput: e.target.value });
                  }}
                ></textarea>
                {areaInput === "" && submeet ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label>Current State</label>
                <input
                  className={`form-control ${!(state)
                    }`}
                  value={state}
                  name="state"
                
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ state: e.target.value });
                  }}
                />
                {submeet && !(state) ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label>City</label>
                <input
                  className={`form-control ${!(city)
                    }`}
                  value={city}
                  name="city"
                
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ city: e.target.value });
                  }}
                />
                {submeet && (!city) ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>


              <div className="form-group">
                <label>Pincode</label>
                <input
                  type="number"
                  className={`form-control ${pinCode === "" && submeet && "parsley-error"
                    }`}
                  value={pinCode}
                  name="number"
                  required=""
                  onChange={(e) => {
                    this.setState({
                      pinCode: e.target.value,
                      submeet: false,
                    });
                  }}
                />
                {pinCode === "" && submeet ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label htmlFor="bloodGroup">Blood Group</label>
                <select
                  className={`form-control ${submeet && !bloodGroup && "parsley-error"
                    }`}
                  value={bloodGroup}
                  name="bloodGroup"
                  required=""
                  onChange={(e) => {
                    this.setState({ bloodGroup: e.target.value });
                  }}
                >
                  <option value="">Select Blood Group</option>
                  <option value="A+">A+</option>
                  <option value="A-">A-</option>
                  <option value="B+">B+</option>
                  <option value="B-">B-</option>
                  <option value="AB+">AB+</option>
                  <option value="AB-">AB-</option>
                  <option value="O+">O+</option>
                  <option value="O-">O-</option>
                </select>
                {submeet && !bloodGroup ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">Blood group is required.</li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label>Are you interested in donating blood Y/N</label>
                <br />
                <label className="fancy-radio">
                  <input
                    data-parsley-errors-container="#error-radio"
                    name="bloodDonate"
                    required=""
                    type="radio"
                    value="Yes"
                    onChange={this.handleBloodDonateChange} // Add onChange event
                    checked={bloodDonate === 'Yes'} // Add checked attribute
                  />
                  <span>
                    <i></i>Yes
                  </span>
                </label>
                <label className="fancy-radio">
                  <input
                    name="bloodDonate"
                    type="radio"
                    value="No"
                    onChange={this.handleBloodDonateChange} // Add onChange event
                    checked={bloodDonate === 'No'} // Add checked attribute
                  />
                  <span>
                    <i></i>NO
                  </span>
                </label>
              </div>
              <div className="form-group">
                <label>Native of</label>
                <select
                  className="form-control"
                  value={nativeOf}
                  name="nativeOf"
                  required=""
                  onChange={this.handleNativeOfChange}
                >
                  <option value="">Select Native Of</option>
                  <option value="Haryana">Haryana</option>
                  <option value="Rajasthan">Rajasthan</option>
                </select>
              </div>

              {/* Home District dropdown */}
              {nativeOf && (
                <div className="form-group">
                  <label>Home District</label>
                  <select
                    className="form-control"
                    value={district}
                    name="district"
                    required=""
                    onChange={this.handleDistrictChange}
                  >
                    <option value="">Select Home District</option>
                    {nativeOf === "Haryana" ? (
                      <>
                        <option value="District 1">Ambala</option>
                        <option value="District 2">Bhiwani</option>

                      </>
                    ) : nativeOf === "Rajasthan" ? (
                      <>
                        <option value="District A">Jaipur</option>
                        <option value="District B">Udaipur</option>
                      </>
                    ) : null}
                  </select>
                </div>
              )}

              {/* Home City dropdown */}
              {district && (
                <div className="form-group">
                  <label>Home City</label>
                  <select
                    className="form-control"
                    value={homeCity}
                    name="homeCity"
                    required=""
                    onChange={this.handleCityChange}
                  >
                    <option value="">Select Home City</option>
                    {/* Render options based on selected district */}
                    {district === "District 1" ? (
                      <>
                        <option value="City 1">Babiyal</option>
                        {/* <option value="City 2">Loharu</option> */}
                      </>
                    ) : district === "District 2" ? (
                      <>


                        <option value="City 2">Loharu</option>
                      </>
                    ) : null}
                    {district === "District A" ? (
                      <>

                        <option value="City A">Bajajnagar</option>
                        {/* <option value="City 2">Loharu</option> */}
                      </>
                    ) : district === "District B" ? (
                      <>
                        <option value="City B">Amber</option>

                      </>
                    ) : null}
                  </select>
                </div>
              )}

              {/* <div className="form-group">
                <label>Caste</label>
                <select
                  className="form-control"
                  value={caste}
                  name="caste"
                  onChange={this.handleCasteChange}
                >
                  <option value="">Select Caste</option>
                  <option value="Caste 1">Caste 1</option>
                  <option value="Caste 2">Caste 2</option>
                 
                </select>
              </div> */}
        <div className="form-group">
      <label htmlFor="caste">Caste</label>
      <select
        className={`form-control ${submeet && !caste && "parsley-error"
          }`}
        value={caste}
        name="caste"
        required=""
        onChange={(e) => {
          this.setState({ caste: e.target.value });
        }}
      >
        <option value="">Select Caste</option>
        {casteData && casteData.map((key) => (
          <option key={key.id} value={key.id}>{key.caste}</option>
        ))}
      </select>
      {submeet && !caste ? (
        <ul className="parsley-errors-list filled" id="parsley-id-29">
          <li className="parsley-required">Caste is required.</li>
        </ul>
      ) : null}
    </div>

    <div className="form-group">
      <label htmlFor="caste">Sub Caste</label>
      <select
        className={`form-control ${submeet && !subcaste && "parsley-error"
          }`}
        value={subcaste}
        name="subcaste"
        required=""
        onChange={(e) => {
          this.setState({ subcaste: e.target.value });
        }}
      >
        <option value="">Select Sub Caste</option>
        {casteData && casteData.map((key) => (
          <option key={key.id} value={key.id}>{key.subcaste}</option>
        ))}
      </select>
      {submeet && !subcaste ? (
        <ul className="parsley-errors-list filled" id="parsley-id-29">
          <li className="parsley-required">Sub Caste is required.</li>
        </ul>
      ) : null}
    </div>
    <div className="form-group">
      <label htmlFor="caste">Gotra</label>
      <select
        className={`form-control ${submeet && !gotra && "parsley-error"
          }`}
        value={gotra}
        name="gotra"
        required=""
        onChange={(e) => {
          this.setState({ gotra: e.target.value });
        }}
      >
        <option value="">Select Gotra</option>
        {casteData && casteData.map((key) => (
          <option key={key.id} value={key.id}>{key.gotra}</option>
        ))}
      </select>
      {submeet && !gotra ? (
        <ul className="parsley-errors-list filled" id="parsley-id-29">
          <li className="parsley-required">Gotra is required.</li>
        </ul>
      ) : null}
    </div>
            
     

     

              <div className="form-group">
                <label htmlFor="bloodGroup">Select Occupation</label>
                <select
                  className={`form-control ${submeet && !category && "parsley-error"
                    }`}
                  value={category}
                  name="category"
                  required=""
                  onChange={(e) => {
                    this.setState({ category: e.target.value });
                  }}
                >
                  <option value="">Select Occupation</option>
                  {categoryData && categoryData.map((key) => (
                    <option key={key.id} value={key.name}>{key.name}</option>
                  ))}
                </select>
                {submeet && !category ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">Category is required.</li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label>Kuldevi/Devata Name :</label>
                <input
                  className={`form-control ${!(kulName)
                    }`}
                  value={kulName}
                  name="kulName"
                 
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ kulName: e.target.value });
                  }}
                />
                {submeet && !(kulName) ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>

              <div className="header">
                <h2>Business Profile</h2>
              </div>
              <div className="form-group">
                <label>Firm Name :</label>
                <input
                  className={`form-control ${!(firmName) 
                    }`}
                  value={firmName}
                  name="firmName"
                    
                  // required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ firmName: e.target.value });
                  }}
                />
                {/* {submeet && (firmName) ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null} */}
              </div>
              <div className="form-group">
                <label>Firm Address :</label>
                <input
                  className={`form-control ${!(firmAddress)
                    }`}
                  value={firmAddress}
                  name="firmAddress"
                
                  // required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ firmAddress: e.target.value });
                  }}
                />
                {/* {submeet && !(firmAddress) ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null} */}
              </div>

              <div className="form-group">
                <label htmlFor="bloodGroup">Deals With :</label>
                <select
                  className={`form-control ${submeet
                    }`}
                  value={dealsWith}
                  name="dealsWith"
                  // required=""
                  onChange={(e) => {
                    this.setState({ dealsWith: e.target.value });
                  }}
                >
                  <option value="">Select</option>
                  <option value="deal 1">Deal 1</option>
                  <option value="deal 2">Deal 2</option>

                </select>
                {/* {submeet && !dealsWith ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">Deals With is required.</li>
                  </ul>
                ) : null} */}
              </div>



          

              <div className="form-group">
                <label>Website :</label>
                <input
                  className={`form-control ${!(website) 
                    }`}
                  value={website}
                  name="website"
                
                  // required=""
                  type="website"
                  onChange={(e) => {
                    this.setState({ website: e.target.value });
                  }}
                />
                {/* {submeet && !reg.test(website) ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null} */}
              </div>
              <div className="form-group">
                <label>Upload Images</label>

                {this.state.currentImageUrls.map((imageUrl, index) => (
                  <div key={index}>
                    <img src={imageUrl} alt={`Image ${index}`} style={{ width: '100px', marginBottom: '10px' }} />
                  </div>
                ))}


                <input
                  type="file"
                  className={`form-control ${!imageInput && submeet && "parsley-error"}`}
                  name="imageInput"
                  required=""
                  multiple
                  onChange={this.handleChangeMultipleImages}
                />
                {!imageInput && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>
              {submissionStatus === 'success' && (
        <div className="alert alert-success" role="alert">
          Form submitted successfully!
        </div>
      )}

      {errorMessages.length > 0 && (
        <div className="alert alert-danger" role="alert">
          {errorMessages.map((msg, index) => (
            <div key={index}>{msg}</div>
          ))}
        </div>
      )}

              <br />
            </form>
            <button
              className="btn btn-primary"
              onClick={(e) => {
                // this.setState({ submeet: true });
                this.handleSubmit(e)
              }}
            >
              Submit
            </button>

          </div>
        </div>


      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default withRouter(connect(mapStateToProps, {})(AddDirectory));
